import React, { Component } from 'react';
import { connect } from 'react-redux';
import  {Form, Errors, actions, Control } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredMultiSelect from '../../../common/form/elements/required-multi-select';
import ArrowButton from '../../../common/button-arrow';
import BackLink from '../../../common/back-link/index';
import { getStockItIncentive, updateStockItIncentive, saveStockItIncentive, downloadCsv } from '../../../../actions/stock-it-incentives';

import './styles.css';

class AddStockItIncentives extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      productList: '',
      groupList: ''
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;

    this.id = +this.props.match.params.id;
    this.newIncentive = isNaN(this.id)
    this.fieldDisabled = !this.newIncentive && this.props.startDateBeforeCurrentDate
    this.edit = !this.newIncentive

    dispatch(getStockItIncentive(this.id)).then(() => {
      if (this.newIncentive) {
        dispatch(actions.change('deep.stock_it_incentives.target', 100));
      }
    });

    if (!this.newIncentive) {
      dispatch(actions.reset('deep.stock_it_incentives'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.stock_it_incentives'));
  }

  createProductList = (products) => {
    return products.map((curr) => {
      return {
        label: `${curr.sku_name} ${curr.sku_code}`,
        value: curr.id
      }
    });
  };

  createGroupList = (groups) => {
    return groups.map((curr) => {
      return {
        label: `${curr.name}`,
        value: curr.id
      }
    });
  };

  onSubmit = (formData) => {
    let { start_date_before_current_date, ...data } = formData
    const { dispatch } = this.props;

    if (this.edit) {
      dispatch(updateStockItIncentive(this.props.incentive.id, data));
    } else {
      dispatch(saveStockItIncentive(data));
    }
  };

  handleDownloadCsv = () => {
    const { dispatch } = this.props;

    dispatch(downloadCsv(this.id));
  };

  render() {
    return (
      <div className="container-fluid incentive-form">
        <Row>
          <Col md={12}>
            <BackLink href="/admin/stock_it_incentives"/>
            <PageTitle>{`${this.edit ? 'View' : 'Add'} stock it incentive`}</PageTitle>
            <ArrowButton
              submit={false}
              arrow={false}
              className="pull-right"
              onClick={this.handleDownloadCsv}
            >Calculate</ArrowButton>
          </Col>
        </Row>
        <Col md={12}>
          <Row>
            <Form model="deep.stock_it_incentives" onSubmit={this.onSubmit}>
              <Errors className="errors" model="deep.stock_it_incentives"/>
              <Row>
                <Col md={3} className="add-incentives">
                  <h4>Incentive Name*</h4>
                </Col>
                <Col md={9}>
                  <RequiredInput
                    model=".name"
                    placeholder="Incentive Name"
                    controlId="loadPoints"/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive Start Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker disabled={this.fieldDisabled}
                                      model="deep.stock_it_incentives.start_date"
                                      controlId="start_date"
                                      value={this.props.startDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive End Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker model="deep.stock_it_incentives.end_date"
                                      controlId="end_date"
                                      value={this.props.endDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Display from Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker model="deep.stock_it_incentives.display_from_date"
                                      controlId="display_from_date"
                                      value={this.props.displayFromDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Display to Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker model="deep.stock_it_incentives.display_to_date"
                                      controlId="display_to_date"
                                      value={this.props.displayToDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Max points*</h4>
                </Col>
                <Col md={9}>
                  <RequiredInput
                    model=".max_points"
                    placeholder="Max points"
                    inputType="number"
                    />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Eligible SKUs*</h4>
                </Col>
                <Col md={9}>
                  <div>
                    <RequiredMultiSelect
                      data={this.createProductList(this.props.products)}
                      value={this.props.savedProducts}
                      disabled={this.fieldDisabled}
                      controlId="products"
                      model='deep.stock_it_incentives.product_ids' />
                  </div>
                </Col>
              </Row>
              <div>
                <Row>
                  <Col md={3}>
                    <h4>Eligible Groups*</h4>
                  </Col>
                  <Col md={9}>
                    <div>
                      <RequiredMultiSelect
                        data={this.createGroupList(this.props.groups)}
                        value={this.props.savedGroups}
                        controlId="groups"
                        model='deep.stock_it_incentives.group_ids'
                        withAllOption={true} />
                    </div>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col md={3}>
                  <h4>Blu</h4>
                </Col>
                <Col md={9}>
                  <Control.checkbox model=".blu">
                  </Control.checkbox>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Blu quantity</h4>
                </Col>
                <Col md={9}>
                  <Control.text
                    className="form-control"
                    model=".blu_quantity"
                    placeholder="Blu quantity"
                    type="number"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Target</h4>
                </Col>
                <Col md={9}>
                  <RequiredInput 
                    model=".target"
                    placeholder="Target"
                    inputType="number"
                    max={100}
                  />
                </Col>
              </Row>
              <Col md={12}>
                <Row>
                  <ArrowButton className="float-right" color="red" disabled={!this.props.formValid || this.props.fetching}>save</ArrowButton>
                </Row>
              </Col>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formData: state.deep.stock_it_incentives,
    formValid: state.deep.forms.incentives.$form.valid,
    incentive: state.stockItIncentives.stock_it_incentive,
    startDate: state.deep.stock_it_incentives.start_date || '',
    endDate: state.deep.stock_it_incentives.end_date || '',
    displayToDate: state.deep.stock_it_incentives.display_to_date || '',
    displayFromDate: state.deep.stock_it_incentives.display_from_date || '',
    savedProducts: state.deep.stock_it_incentives.product_ids || [],
    savedGroups: state.deep.stock_it_incentives.group_ids || [],
    startDateBeforeCurrentDate: state.deep.stock_it_incentives.start_date_before_current_date || false,
    meta: state.stockItIncentives.meta,
    products: state.stockItIncentives.meta.products || [],
    groups: state.stockItIncentives.meta.groups || [],
    fetching: state.stockItIncentives.fetching,
    fetched: state.stockItIncentives.fetched
  };
};

export default connect(mapStateToProps)(AddStockItIncentives);



// WEBPACK FOOTER //
// ./src/components/admin/stock-it-incentives/add-stock-it-incentives/index.jsx